import { Button, Typography } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { TotalEstimatedSpendModal } from '@hero/components/modals';
import { PAYMENT_METHOD_TYPES } from '@hero/constants';
import { useGetRecognition, useGetRecognitionSpendingSummary } from '@hero/services';
import { formatCurrency } from '@hero/utils';

import * as S from './style';

function NavigationSecondaryContent() {
  const { t } = useTranslation();
  const { recognitionCode } = useParams();
  const { data: recognition } = useGetRecognition({
    recognitionCode
  });
  const { data: recognitionSpendingSummary } = useGetRecognitionSpendingSummary({
    recognitionCode
  });

  const [isEstimatedTotalModalOpen, setIsEstimatedModalOpen] = useState(false);

  return (
    <S.NavigationSecondaryContent>
      <Typography variant="body2Bold">
        <Trans
          i18nKey="youWillChargedX"
          values={{ price: formatCurrency(recognitionSpendingSummary?.estimatedCharges?.total) }}
          components={{
            div: (
              <Typography
                style={{ marginLeft: 8, color: 'var(--color-success-stronger)' }}
                variant="body1ExtraBold"
                as="span"
                color="primary"
                emphasis="700"
              />
            )
          }}
        />
      </Typography>
      <Button
        onClick={() => setIsEstimatedModalOpen(true)}
        variant="link"
        color="neutral"
        emphasis="500"
        style={{ textTransform: 'none' }}
      >
        <Typography color="neutral" emphasis="500" variant="caption1">
          {t('howOurPriceWork')}
        </Typography>
      </Button>

      <TotalEstimatedSpendModal
        isCCPayment={recognition?.paymentMethod?.type === PAYMENT_METHOD_TYPES.creditCard}
        isModalOpen={isEstimatedTotalModalOpen}
        onModalOpen={() => setIsEstimatedModalOpen(false)}
      />
    </S.NavigationSecondaryContent>
  );
}

export { NavigationSecondaryContent };
